import { ComponentType } from "react";

import { HourglassIcon } from "../components/icons/HourglassIcon";
import { IconBaseProps } from "../components/icons/IconBase";
import { SmartphoneIcon } from "../components/icons/SmartphoneIcon";
import { StarOutlineIcon } from "../components/icons/StarOutlineIcon";
import { UsersIcon } from "../components/icons/UsersIcon";

export interface ClubStat {
  id: string;
  value: string;
  description: string;
  icon: ComponentType<IconBaseProps>;
}

export const CLUB_STATS: ClubStat[] = [
  { id: "members", value: "+ 1,5 M", description: "membres", icon: UsersIcon },
  {
    id: "monthly-users",
    value: "+ 200 K",
    description: "utilisateurs mensuels",
    icon: SmartphoneIcon,
  },
  {
    id: "services",
    value: "+ 100 K",
    description: "services utilisés/mois",
    icon: StarOutlineIcon,
  },
  {
    id: "experience",
    value: "+40 ans",
    description: "d’expérience dans le monde automobile",
    icon: HourglassIcon,
  },
];
